<template>
  <DrawingForm />
</template>
  
<script>
  import DrawingForm from '@/components/drawing/DrawingForm.vue';
  export default {
    name: "DrawingCreatePage",
    components: {
      DrawingForm,
    },
  };
</script>
  